import React from "react";
import './style.scss';
import SectionItemSelect from "../SectionItemSelect/SectionItemSelect.jsx";
import {CREDIT_ACCEPT, getDepotPaymentValue} from "../../../utils/enums.js";
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";

const DepotPaymentSelector = (props) => {
    const {t} = useTranslation();
    const paymentsConfiguration = useSelector(state => state.restaurant.data.paymentsConfiguration);

    const getDefaultValue = (key) => {
        const value = getDepotPaymentValue().find(item => item.key === key);
        return value.value;
    }

    if(props.item.creditAcceptType.value !== CREDIT_ACCEPT.selling) {
        return null;
    }

    return (
        <div className={'depotPaymentSelector'}>
            <div className={'paymentItem'}>
                <SectionItemSelect
                    value={props.item.acceptCreditCard}
                    values={getDepotPaymentValue()} column={{
                    isReadonly: paymentsConfiguration.overrideDepotSettings,
                    title: t('settings.paymeWallet.CREDIT_ACCEPT_ORDERS_CARD'),
                    onPropChange: (data) => props.onPropChange({
                        acceptCreditCard: data.key
                    }),
                }}
                />
                {(props.item.acceptCreditCard === null || paymentsConfiguration.overrideDepotSettings) && (
                    <div className={'defaultValue'}>
                        {paymentsConfiguration.overrideDepotSettings ? t('settings.paymeWallet.DEFAULT_GLOBAL_VALUE') : t('settings.paymeWallet.DEFAULT_VALUE')}
                        &nbsp;
                        {getDefaultValue(paymentsConfiguration.acceptCreditCard)}
                    </div>
                )}
            </div>

            <div className={'paymentItem'}>
                <SectionItemSelect
                    value={props.item.acceptCash}
                    values={getDepotPaymentValue()}
                    column={{
                        isReadonly: paymentsConfiguration.overrideDepotSettings,
                        title: t('settings.paymeWallet.CREDIT_ACCEPT_ORDERS_CASH'),
                        onPropChange: (data) => props.onPropChange({
                            acceptCash: data.key
                        }),
                    }}
                />
                {(props.item.acceptCash === null || paymentsConfiguration.overrideDepotSettings) && (
                    <div className={'defaultValue'}>
                        {paymentsConfiguration.overrideDepotSettings ? t('settings.paymeWallet.DEFAULT_GLOBAL_VALUE') : t('settings.paymeWallet.DEFAULT_VALUE')}
                        &nbsp;
                        {getDefaultValue(paymentsConfiguration.acceptCash)}
                    </div>
                )}
            </div>

            <div className={'paymentItem'}>
                <SectionItemSelect
                    value={props.item.acceptCashOnTakeAway}
                    values={getDepotPaymentValue()}
                    column={{
                        isReadonly: paymentsConfiguration.overrideDepotSettings,
                        title: t('settings.paymeWallet.CREDIT_ACCEPT_ORDERS_CASH_ON_TAKE_AWAY'),
                        onPropChange: (data) => props.onPropChange({
                            acceptCashOnTakeAway: data.key
                        }),
                    }}
                />
                {(props.item.acceptCashOnTakeAway === null || paymentsConfiguration.overrideDepotSettings) && (
                    <div className={'defaultValue'}>
                        {paymentsConfiguration.overrideDepotSettings ? t('settings.paymeWallet.DEFAULT_GLOBAL_VALUE') : t('settings.paymeWallet.DEFAULT_VALUE')}
                        &nbsp;
                        {getDefaultValue(paymentsConfiguration.acceptCashOnTakeAway)}
                    </div>
                )}
            </div>
        </div>
    )
}

export default DepotPaymentSelector;